<customized-section></customized-section> 
<app-reasons></app-reasons> 
<app-solutions></app-solutions> 
<app-technologies></app-technologies>
<clients-say></clients-say>
<cost-plan-card></cost-plan-card>
<app-reach-out-section></app-reach-out-section>
<app-work-flow-section></app-work-flow-section>